import Link from 'antd/es/typography/Link';

export type WorkerLinkProps = {
  enterpriseId: string;
};

export const WorkerLink = ({ enterpriseId }: WorkerLinkProps) =>
  enterpriseId ? (
    <Link target="_blank" href={`https://workers.intel.com/#/worker/${enterpriseId}`}>
      {enterpriseId}
    </Link>
  ) : null;
